import { css } from '@emotion/react'
import { gemVar, Spacing, ThemedColors } from '@opallabs/gem'

const rootClass = 'opal-calendar-control-bar'
export const selectors = { root: rootClass } as const

/**
 * Three tracks rather than `space-between`, so the date lockup sits in the
 * middle of the row whatever width the controls either side of it take.
 */
export const root = css({
  alignItems: 'center',
  backgroundColor: gemVar(ThemedColors.Surface1),
  blockSize: Spacing.XL,
  boxSizing: 'border-box',
  display: 'grid',
  flex: 'none',
  gap: Spacing.S,
  gridTemplateColumns: '1fr auto 1fr',
  paddingBlock: Spacing.S,
  paddingInline: Spacing.M,
})

export const start = css({
  alignItems: 'center',
  display: 'flex',
  gap: Spacing.S,
  minInlineSize: 0,
})

export const center = css({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
})

export const end = css({
  alignItems: 'center',
  display: 'flex',
  gap: Spacing.S,
  justifySelf: 'end',
})
